// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scroll-button[data-v-4493abbc]{background:#fff;border-radius:50%;height:2.25rem;width:2.25rem;align-self:flex-end;box-shadow:0 2px 4px rgba(0,0,0,.075)}@media(min-width:62rem){.scroll-button[data-v-4493abbc]{display:none}}.scroll-button__icon[data-v-4493abbc]{width:24px;height:24px}", ""]);
// Exports
module.exports = exports;
